import { createTheme, ThemeOptions } from '@mui/material/styles';
import COLORS from './Themes';

const sharedButtonStyle = {
  textTransform: 'capitalize' as const,
  borderRadius: 12,
  transition: 'transform 0.3s ease, background-color 0.15s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
  },
};

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: COLORS.SAFEGUARD_BLUE,
    },
    secondary: {
      main: COLORS.SAFEGUARD_ORANGE,
    },
    complete: {
      main: COLORS.BLUE_CRAYOLA,
    },
  },
  // TODO: Add when we are ready to use it
  shape: {
    //borderRadius: 8,
   },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'contained'},
              style: {
                ...sharedButtonStyle,
                color: COLORS.WHITE,
                fontWeight: 400,
                boxShadow: '0 3px 1px -2px rgba(0, 0, 0, 0.14)',
                '&:hover': {
                  ...sharedButtonStyle['&:hover'],
                },
              },
            },
            {
              props: { variant: 'outlined' },
              style: {
                ...sharedButtonStyle,
              },
            },
                        {
              props: { variant: 'text' },
              style: {
                ...sharedButtonStyle,
              },
            },
          ],
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
    },
  },
};

export const theme = createTheme(themeOptions);

declare module '@mui/material/styles' {
  interface Palette {
    complete: Palette['primary'];
    pending: Palette['primary'];
  }
  interface PaletteOptions {
    complete?: PaletteOptions['primary'];
    pending?: PaletteOptions['primary'];
  }

}

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    complete: true;
    pending: true;
  }
}
